export interface EmailChangeStatusDto {
  pendingEmail: string | null;
}

export interface SessionDto {
  id: string;
  deviceName: string | null;
  ip: string | null;
  lastSeenAt: string;
  createdAt: string;
  /** True for the session whose token authorized this request */
  isCurrent: boolean;
}

export interface TwoFactorSetupDto {
  otpauthUrl: string;
  /** PNG data URI, rendered as the QR image directly */
  qrCodeDataUrl: string;
  manualKey: string;
}

/** The backend refuses a phone number another live account holds with this code (PhoneTakenException) */
export const phoneTakenErrorCode = 'PHONE_TAKEN';
